import React from "react";
import { steps } from "../mock";

import { tr } from "../i18n";
export default function HowItWorks() {
  return (
    <section
      id="how-it-works"
      className="bg-[#0b1f3a] py-20 md:py-28 relative overflow-hidden scroll-mt-20"
    >
      <div className="pointer-events-none absolute top-0 right-0 w-[400px] h-[400px] rounded-full border border-[#c2a15a]/10" />
      <div className="max-w-7xl mx-auto px-5 md:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          <div>
            <div className="deco-line w-24 mb-6" />
            <h2 className="font-display text-white text-[34px] md:text-[46px] leading-tight">
              {tr("Diversify risk, optimise returns, save time")}
            </h2>
            <p className="text-white/60 text-[17px] mt-4 mb-10">
              {tr("Three simple steps stand between your idle cash and market-leading returns.")}
            </p>

            <div className="space-y-8">
              {steps.map((s) => (
                <div key={s.n} className="flex gap-5 reveal">
                  <div className="shrink-0 w-14 h-14 rounded-full border border-[#c2a15a]/50 flex items-center justify-center font-display text-[20px] text-[#c2a15a]">
                    {s.n}
                  </div>
                  <div>
                    <h3 className="text-white font-semibold text-[19px]">
                      {s.title}
                    </h3>
                    <p className="text-white/60 text-[15px] mt-1 leading-relaxed max-w-md">
                      {s.body}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Portfolio visual */}
          <div className="reveal">
            <div className="rounded-2xl bg-white/[0.04] ring-1 ring-[#c2a15a]/20 p-6 md:p-8 backdrop-blur">
              <p className="text-white/50 text-[12px] uppercase tracking-widest">
                {tr("Example portfolio")}
              </p>
              <p className="font-display text-white text-[30px] mt-1">
                £2,400,000{" "}
                <span className="text-[15px] text-white/40 font-sans">
                  {tr("across 6 institutions")}
                </span>
              </p>
              <div className="mt-6 space-y-3">
                {[
                  { n: "Aldermore — 95 Day Notice", v: "£500,000", p: "78%" },
                  { n: "OakNorth — 1 Year Fixed", v: "£500,000", p: "68%" },
                  { n: "Investec — Instant Access", v: "£450,000", p: "60%" },
                  { n: "Close Brothers — 6 Month", v: "£400,000", p: "52%" },
                  { n: "Al Rayan — Fixed Term", v: "£350,000", p: "44%" },
                  { n: "Nationwide — Notice", v: "£200,000", p: "30%" },
                ].map((row) => (
                  <div key={row.n}>
                    <div className="flex justify-between text-[13px] mb-1">
                      <span className="text-white/70">{tr(row.n)}</span>
                      <span className="text-[#c2a15a] font-medium">{row.v}</span>
                    </div>
                    <div className="h-1.5 rounded-full bg-white/10 overflow-hidden">
                      <div
                        className="h-full rounded-full bg-[#c2a15a]"
                        style={{ width: row.p }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
